// Selector to opening the modal
export const selectIsModalOpen = (state) => state.productModal.isOpen;

// Selector to get data of the product
export const selectProductData = (state) => state.productModal.productData;
